module.exports = __webpack_public_path__ + "img/en_Beta Digitis - Gif.750400d1.gif";